import coreModule from 'app/core/core_module';

export class Freshchat {
  /** @ngInject */
  constructor(private $rootScope, private contextSrv, private $window) {}

  init() {
    return;

    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    this.$rootScope.$on('$viewContentLoaded', () => {
      if (this.contextSrv.isSignedIn && this.contextSrv.user && this.contextSrv.user.id) {
        // To set unique user id in your system when it is available
        this.$window.fcWidget.setExternalId(this.contextSrv.user.id);

        // To set user email
        this.$window.fcWidget.user.setEmail(this.contextSrv.user.email);

        // To set user properties
        /*
          window.fcWidget.user.setProperties({
            plan: "Estate",                 // meta property 1
            status: "Active"                // meta property 2
          });
          */
      }
    });
  }
}

/** @ngInject */
function startFreshchat(freshchatSrv) {
  freshchatSrv.init();
}

coreModule.service('freshchatSrv', Freshchat).run(startFreshchat);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/services/freshchat.ts